// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"

Turbo.StreamActions.fill = function () {
  let template = null

  try {
    template = this.templateContent.textContent
  } catch (e) {
    // default to empty object
  }

  try {
    // const detail = template ? JSON.parse(template) : {}
    console.log(this.target)
    document.getElementById(this.target).setAttribute('fill', template)

    
  } catch (e)  {
    console.error(e)
  }
};

import "trix"
import "@rails/actiontext"
